import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import {
    withHookForChapter,
    withUpdateChapter,
} from "src/modules/book/operations";
import { compose } from "src/helpers";

import EditView from "./component";

const Edit = (props) => {
    const { updateChapter } = props;
    const router = useRouter();
    const {
        query: { redirect_to },
    } = router;

    const {
        query: { book_id },
    } = router;

    const onFinish = async (values: any) => {
        await updateChapter(values);
        // router.push(`/tab/chapter/${book_id}`);
        router.push(redirect_to);
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <EditView
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            {...props}
            disableHasTopics={true}
        />
    );
};

export default compose(withHookForChapter, withUpdateChapter)(Edit);
